import { parsePurchaseOrders, parsePurchaseOrderCandidates, parsePurchaseOrderManagement } from "./purchase-order-read-contracts";
import { apiRequest, getRolePreview } from "../../../../shared/api/client";
import type {
  PurchaseOrder,
} from "../../domain/models";

export const purchaseOrderGateway = {
  list: async () => parsePurchaseOrders(await apiRequest<unknown>("/api/purchase-orders")),
  candidates: async () => parsePurchaseOrderCandidates(await apiRequest<unknown>("/api/purchase-orders/candidates")),
  managementOverview: async () => parsePurchaseOrderManagement(await apiRequest<unknown>("/api/purchase-orders/management-overview")),
  create: (requestNo: string, idempotencyKey: string) =>
    apiRequest<PurchaseOrder>("/api/purchase-orders", {
      method: "POST",
      body: JSON.stringify({
        requestNo,
        idempotencyKey,
      }),
    }),
  send: (id: string, input: { deliveryAddress: string }) =>
    apiRequest<PurchaseOrder>(`/api/purchase-orders/${id}/send`, {
      method: "POST",
      body: JSON.stringify(input),
    }),
  receive: (
    id: string,
    input: {
      quantity: number;
      deliveredAt: string;
      expectedQuantity: number;
      returnQuantity: number;
      returnReason?: string;
      returnDisposition?: "REPLACE" | "DEDUCT_FROM_ORDER";
      receiptNote?: string;
      deliveryNoteNo: string;
      document: File;
      idempotencyKey: string;
    },
  ) => {
    const body = new FormData();
    body.append("quantity", String(input.quantity));
    body.append("deliveredAt", input.deliveredAt);
    body.append("expectedQuantity", String(input.expectedQuantity));
    body.append("returnQuantity", String(input.returnQuantity));
    if (input.returnReason) body.append("returnReason", input.returnReason);
    if (input.returnDisposition)
      body.append("returnDisposition", input.returnDisposition);
    if (input.receiptNote) body.append("receiptNote", input.receiptNote);
    body.append("deliveryNoteNo", input.deliveryNoteNo);
    body.append("idempotencyKey", input.idempotencyKey);
    body.append("file", input.document);
    return apiRequest<PurchaseOrder>(`/api/purchase-orders/${id}/deliveries`, {
      method: "POST",
      body,
    });
  },
  documentUrl: (orderId: string, documentId: string) =>
    `${getRolePreview() ? "/api/demo" : "/api"}/purchase-orders/${encodeURIComponent(orderId)}/documents/${encodeURIComponent(documentId)}?preview=1`,
  reviewQuality: (
    orderId: string,
    deliveryId: string,
    input: {
      qualityStatus: "ACCEPTED" | "CONDITIONAL" | "REJECTED";
      qualityNote?: string;
      rejectionDisposition?:
        | "REPLACE"
        | "DEDUCT_FROM_ORDER"
        | "CONDITIONAL_ACCEPTANCE"
        | "CREATE_CAPA";
    },
  ) =>
    apiRequest<PurchaseOrder>(
      `/api/purchase-orders/${orderId}/deliveries/${deliveryId}/quality`,
      {
        method: "POST",
        body: JSON.stringify(input),
      },
    ),
  cancel: (id: string, reason: string) =>
    apiRequest<PurchaseOrder>(`/api/purchase-orders/${id}/cancel`, {
      method: "POST",
      body: JSON.stringify({ reason }),
    }),
};
